<template>
  <div class="register-step box">

    <div v-if="item">
      <h2>{{ $t("components.register.registerform.register") }}</h2>

      <profile-form
        v-if="item"
        :form="form"
        :user="item"
        :loading="loading"
        @submit="submitAndReload"
      >
        <hr />

        <b-row>
          <b-col>
            <forms-validated-input
              name="accept_conditions"
              :label="($t('users.fields.accept_conditions') + '*') | capitalize"
              :rules="form.general.accept_conditions.rules"
              type="checkbox"
              :placeholder="placeholderOrLabel('accept_conditions', 'users') | capitalize"
              v-model="item.accept_conditions"
            />
            <forms-validated-input
              name="gdpr"
              :label="($t('users.fields.gdpr') + '*') | capitalize"
              :rules="form.general.gdpr.rules"
              type="checkbox"
              :placeholder="placeholderOrLabel('gdpr', 'users') | capitalize"
              v-model="item.gdpr"
            />
            <forms-validated-input
              name="newsletter"
              :label="$t('users.fields.newsletter') | capitalize"
              :rules="form.general.newsletter.rules"
              type="checkbox"
              :placeholder="placeholderOrLabel('newsletter', 'users') | capitalize"
              v-model="item.newsletter"
            />
          </b-col>
        </b-row>
      </profile-form>
      <layout-loading v-else />
    </div>

    <layout-loading v-if="!item" />

  </div>
</template>

<script>
import Authenticated from "@/mixins/Authenticated";
import Notification from "@/mixins/Notification";
import UserMixin from "@/mixins/UserMixin";

import CommunityProofForm from "@/components/Community/ProofForm.vue";
import ProfileForm from "@/components/Profile/ProfileForm.vue";

import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";
import FormLabelsMixin from "@/mixins/FormLabelsMixin";
import FormMixin from "@/mixins/FormMixin";

import { extractErrors } from "@/helpers";

import SmilingHeart from "@/assets/svg/smiling-heart.svg";
import Driving from "@/assets/svg/driving.svg";
import Lend from "@/assets/svg/home-lend.svg";
import Biking from "@/assets/svg/biking.svg";

export default {
  name: "RegisterProfile",
  mixins: [Authenticated, FormLabelsMixin, FormMixin, Notification, UserMixin],
  components: {
    CommunityProofForm,
    FormsValidatedInput,
    ProfileForm,
    "svg-driving": Driving,
    "svg-lend": Lend,
    "svg-smiling-heart": SmilingHeart,
    "svg-biking": Biking,
  },
  data() {
    return { currentSlide: 1, proofLoading: false };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if( vm.isLoggedIn && !vm.isRegistered) {
        vm.$store.dispatch(`users/retrieveOne`, {
          id: 'me',
          params: vm.$route.meta.params,
        });
      }
    })
  },
  props: {
    id: {
      required: false,
    },
  },
  computed: {
    // item is loaded manually in beforeRouteEnter
    skipLoadItem() {
      return true;
    },
  },
  methods: {
    nextSlide() {
      this.currentSlide += 1;
    },
    async submitAndReload() {
      try {
        await this.submit(false);
        this.$store.commit("user", this.item);

        if( this.isAdmin ) {
            this.$router.push("/admin");
        } else if( this.hasCommunity ) {
          // it was an invitation, skip the step-by-step registration process
          this.$router.push("/app");
        } else {
          // Skip "Submit proof of residency" third step
          this.$router.push("/register/4");
        }
      } catch (e) {
        if (e.request) {
          switch (e.request.status) {
            case 422:
            default:
              this.$store.commit("addNotification", {
                content: extractErrors(e.response.data).join(", "),
                title: "Erreur d'inscription",
                variant: "danger",
                type: "register",
              });
          }
        }
      }
    },
    async submitCommunityProof() {
      try {
        this.proofLoading = true;
        // File attached
        await this.submit(false);
        // Go to the on-boarding slides
        this.$router.push("/register/4");
      } catch (e) {
        if (e.request) {
          switch (e.request.status) {
            case 422:
            default:
              this.$store.commit("addNotification", {
                content: extractErrors(e.response.data).join(", "),
                title: "Erreur d'inscription",
                variant: "danger",
                type: "register",
              });
          }
        }
      } finally {
        this.proofLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.register-step {
  background-color: $white;
  padding: 53px $grid-gutter-width / 2 45px;
  width: 590px;
  max-width: 100%;
  margin: 50px auto;

  &__intents > h2 {
    margin-bottom: 50px;
  }

  &__title {
    text-align: center;
  }

  h2,
  h3 {
    text-align: center;
  }

  h2 {
    margin-top: 30px;
    font-size: 26px;
    font-weight: 600;
  }

  h3 {
    color: grey;
    font-size: 20px;
    margin: 20px 0;
    font-weight: 400;
  }

  .community-proof-form {
    margin-bottom: 2em;
  }

  &__completed__button {
    text-align: center;
  }

  &__community {
    .headers {
      margin: 20px 0;
      h4 {
        color: grey;
        font-size: 16px;
      }
    }
  }
}
</style>
